export const ChannelPostsMode = {
	MINE: 'mine',
	MENTIONS: 'mentions',
};
